import React from 'react';
import { connect } from 'react-redux';
import {
  addToCart,
  removeFromCart,
} from '../../../redux/shopping/shoppingActions';
const SingleCart = ({ ItemData, addToCart, removeFromCart, cart }) => {
  const currentProduct = cart.find((c) => c.id === ItemData.id);

  let isStock = false;

  if (currentProduct) {
    isStock = currentProduct.quantity >= ItemData.totalProduct;
  }

  let notInStock = false;
  if (currentProduct) {
    notInStock = currentProduct.quantity === 0;
  }
  return (
    <div class="flex justify-between border-b-2 mb-2">
      <div class="text-lg py-2">
        <p>{ItemData.title}</p>
      </div>
      <div class="text-lg py-2">
        <div class="flex flex-row space-x-2 w-full items-center rounded-lg">
          <button
            disabled={notInStock}
            onClick={() => removeFromCart(ItemData.id)}
            class="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18 12H6"
              />
            </svg>
          </button>
          <p>{ItemData.quantity}</p>
          <button
            disabled={isStock}
            onClick={() => addToCart(ItemData.id)}
            class="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (id) => dispatch(addToCart(id)),
    removeFromCart: (id) => dispatch(removeFromCart(id)),
  };
};
const mapStateToProps = (state) => {
  return {
    cart: state.shop.cart,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SingleCart);
